var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2532 8379 c-156 -30 -288 -173 -312 -336 -13 -93 -13 -5543 0 -5636 24 -167 156 -306 321 -337 33 -6 709 -10 1864 -10 l1812 0 19 -42 c106 -236 353 -440 629 -520 70 -20 102 -23 260 -23 214 0 290 16 450 95 195 96 351 252 445 445 82 166 95 229 94 440 0 167 -2 186 -27 268 -101 329 -351 579 -669 671 l-83 24 -3 1693 -2 1694 -799 793 -799 792 -1579 -1 c-868 -1 -1597 -5 -1621 -10z m2998 -1154 l0 -615 630 0 630 0 0 -1618 0 -1618 -53 -22 c-151 -63 -334 -213 -424 -347 -81 -121 -121 -217 -157 -377 l-6 -28 -1700 0 -1700 0 0 2620 0 2620 1390 0 1390 0 0 -615z m1699 -4324 l31 -29 0 -155 0 -156 161 -3 161 -3 29 -33 c25 -28 29 -40 29 -92 0 -52 -4 -64 -29 -92 l-29 -33 -156 -3 -156 -3 -1 -132 c0 -147 -10 -190 -52 -221 -36 -27 -122 -28 -161 -2 -46 29 -56 70 -56 221 l0 135 -149 0 c-146 0 -150 1 -180 26 -59 49 -62 152 -5 205 24 23 32 24 180 27 l154 3 0 135 c0 198 21 234 136 234 54 0 66 -3 93 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3260 6955 l0 -185 720 0 720 0 0 185 0 185 -720 0 -720 0 0 -185z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3260 5805 l0 -145 1515 0 1515 0 0 145 0 145 -1515 0 -1515 0 0 -145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3260 5065 l0 -145 1515 0 1515 0 0 145 0 145 -1515 0 -1515 0 0 -145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3260 4325 l0 -145 1515 0 1515 0 0 145 0 145 -1515 0 -1515 0 0 -145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3260 3585 l0 -145 1515 0 1515 0 0 145 0 145 -1515 0 -1515 0 0 -145z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.456e90f5f83d3ae25525cfd3770265c3.svg";
export { ForwardRef as ReactComponent };